<template>
	<section class="align-left">
		<div class="row row-header align-left">
			<!-- <h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<nuxt-link v-if="moreButtonLabel" class="button button-no-fill" :to="localePath('rooms')">
					{{ moreButtonLabel }}
				</nuxt-link>
			</div> -->
		</div>
		<div class="row promotions-row flex-row slide-row">
			<client-only>
				<EventOverviewCard v-for="event in items.slice(0, 4)" :key="event.ID" :event="event" />
			</client-only>
		</div>
	</section>
</template>

<script setup>
import EventOverviewCard from '~/components/EventOverviewCard.vue';

// const localePath = useLocalePath();
const { fetchDefaults } = useDefaults();

await fetchDefaults();

defineProps({
	items: { type: Array, default: () => [] },
	subtitle: { type: String, default: '' },
	header: { type: String, default: '' },
	moreButtonLabel: { type: String, default: '' },
});
</script>
